<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入名称"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select class="mr10" clearable  v-model="province" placeholder="请选择" size="small">
        <el-option
          v-for="item in region"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-select class="mr10" clearable  v-model="city" placeholder="请选择" size="small">
        <el-option
          v-for="item in cityList"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-select class="mr10" clearable  v-model="area" placeholder="请选择" size="small">
        <el-option
          v-for="item in areaList"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="190px" align="center" label="培训封面">
        <template #default="scope">
          <el-image
            fit="cover"
            class="cover"
            v-if="scope.row.cover"
            :src="$utils.fileUrl(scope.row.cover)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.cover)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        header-align="center"
        label="活动标题"
      ></el-table-column>
      <el-table-column prop="name" label="发布者" header-align="center">
      </el-table-column>
      <el-table-column prop="username" align="center" label="举办时间">
        <template #default="scope">
          <li>
            {{ $utils.formatDate(scope.row.startTime, "yyyy-MM-dd hh:mm") }}
          </li>
          <li>
            {{ $utils.formatDate(scope.row.endTime, "yyyy-MM-dd hh:mm") }}
          </li>
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="活动地址">
        <template #default="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>
      <el-table-column label="活动人数" align="center">
        <template #default="scope">{{ scope.row.maxNumber }}人 </template>
      </el-table-column>
      <el-table-column label="链接地址" align="center">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="info(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="审核操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleEdit(scope.row.id, 1)"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="handleEdit(scope.row.id, 2)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog
      title="活动详情"
      v-model="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <div class="cover-title">
          <el-image
            class="cover"
            :src="$utils.fileUrl(itemData.cover)"
            fit="cover"
            :preview-src-list="[$utils.fileUrl(itemData.cover)]"
          ></el-image>
          <div class="title-name">
            <li>活动标题：{{ itemData.title }}</li>
            <li>发布者：{{ itemData.name }}</li>
            <li>
              活动时间：
              {{ $utils.formatDate(itemData.startTime, "yyyy-MM-dd hh:mm") }}~
              {{ $utils.formatDate(itemData.endTime, "yyyy-MM-dd hh:mm") }}
            </li>
          </div>
        </div>
        <div class="remark">
          <li class="title">活动说明</li>
          <div class="remark-content">
            <p v-html="itemData.remark"></p>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      dialogVisible: false,
      cityList: [],
      areaList: [],
      province: "",
      city: "",
      area: "",
    };
  },
  methods: {
    async getData(page = 1) {
      if(this.searchName.length>30){
        this.$message.warning('搜索内容最多输入30个字')
        return
      }
      const params = {
        content: this.searchName,
        province: this.province,
        city: this.city,
        area: this.area,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.event.reviewed.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    handleEdit(id, status) {
      if (!this.loading) {
        const text =
          status === 1 ? "是否确认通过审核？" : "是否确认不通过审核？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
              status: status,
            };
            const res = await this.$api.event.reviewed.setAudit(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              if (status === 1) {
                this.$message.success("通过成功");
              } else {
                this.$message.success("驳回成功！");
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    info(data) {
      this.itemData = data;
      this.dialogVisible = true;
    },
  },
  created() {
    this.getData();
  },
  computed: {
    region() {
      return this.$utils.getRegion();
    },
  },
  watch:{
    province:{
      handler(val, ovl) {
        this.region.forEach(item=>{
          if(item.label===val){
            this.cityList = item.children
          }
        })
      },
    },
    city:{
      handler(val, ovl) {
        this.cityList.forEach(item=>{
          if(item.label===val){
            this.areaList = item.children
          }
        })
      },
    }
  }
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.video {
  height: 500px;
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  .remark {
    .title {
      margin: 24px 0;
      padding-left: 10px;
      font-size: 1.125rem;
      border-left: 2px solid #409eff;
    }

    .remark-content {
      font-size: 0.875rem;
      p {
        line-height: 26px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
</style>